export enum EnumTypeTable {
    NCM = 'NCM',
    NBS = 'NBS',
}